import {handleActions} from 'redux-actions';
import {Map} from 'immutable';

import * as Actions from './actions';
import AccidentIncidentReport from './model';

export default handleActions(
    {
        [Actions.createSuccess.type]: (state, {payload}) => {
            return state.set(payload.report.reportId, payload.report);
        },
        [Actions.updateSuccess.type]: (state, {payload}) => {
            return state.set(payload.report.reportId, payload.report);
        },
        [Actions.fetchAllForChildSuccess.type]: (state, {payload}) => {
            const resultMap = Map(payload.reports.map(r => [r.reportId, r]));
            return state.merge(resultMap);
        },
        [Actions.fetchWithIdsSuccess.type]: (state, {payload}) => {
            const resultMap = Map(payload.reports.map(r => [r.reportId, r]));
            return state.merge(resultMap);
        },
        [Actions.acknowledge.type]: (state, {payload}) =>
            state.update(payload.reportId, AccidentIncidentReport.default, report =>
                report.merge({
                    updatingAcknowledged: true,
                }),
            ),
        [Actions.acknowledgeFailed.type]: (state, {payload}) =>
            state.update(payload.reportId, AccidentIncidentReport.default, report =>
                report.merge({
                    updatingAcknowledged: false,
                }),
            ),
        [Actions.deleteReportSuccess.type]: (state, {payload}) => state.delete(payload.reportId),
    },
    new Map(),
);
